import { Link } from 'react-router-dom';
import { Mail, MapPin, Globe } from 'lucide-react';
import { ORG } from '../data/content';

const EXPLORE = [
  { label: 'Home', path: '/' }, { label: 'Services', path: '/services' }, { label: 'About', path: '/about' },
  { label: 'Case Studies', path: '/case-studies' }, { label: 'Insights', path: '/insights' }, { label: 'Contact', path: '/contact' },
];

const EXPERTISE = [
  { label: 'Management Consulting', path: '/services#management-consulting' },
  { label: 'Market Research', path: '/services#market-research' },
  { label: 'Public Policy', path: '/services#public-policy' },
  { label: 'Technology & Digital', path: '/services#technology-digital' },
  { label: 'Infrastructure & Sustainability', path: '/services#infrastructure-sustainability' },
  { label: 'Capacity Building', path: '/services#capacity-building' },
];

export default function Footer() {
  return (
    <footer className="bg-brand-deep text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="inline-block rounded-xl bg-white p-4" data-testid="footer-logo-block">
              <img src="/assets/logo-footer.webp" alt="INSIGHTS STRATEGY — Research, Strategy, Impact" className="h-auto w-[230px]" />
            </div>
            <p className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-white/60">{ORG.division}</p>
            <p className="mt-3 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-white/45">
              Research <span className="h-3 w-px bg-brand-green" /> Strategy <span className="h-3 w-px bg-brand-green" /> Impact
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
              Research-driven management consulting, market intelligence and strategic advisory for organisations navigating complexity.
            </p>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-xs font-bold uppercase tracking-[0.22em] text-white/40">Explore</h3>
            <ul className="mt-5 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-sm text-white/70 transition-colors hover:text-brand-green" data-testid={`footer-explore-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-xs font-bold uppercase tracking-[0.22em] text-white/40">Expertise</h3>
            <ul className="mt-5 space-y-3">
              {EXPERTISE.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-sm text-white/70 transition-colors hover:text-brand-green" data-testid={`footer-expertise-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-xs font-bold uppercase tracking-[0.22em] text-white/40">Contact</h3>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-0.5 shrink-0 text-brand-green" />
                <a href={`mailto:${ORG.email}`} className="transition-colors hover:text-brand-green" data-testid="footer-email-link">{ORG.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-0.5 shrink-0 text-brand-green" />
                <span>{ORG.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Globe size={15} className="mt-0.5 shrink-0 text-brand-green" />
                <span>{ORG.website}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-white/45" data-testid="footer-copyright">
            © 2026 Kalpataru Enterprise. INSIGHTS STRATEGY is a division of Kalpataru Enterprise. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <Link to="/privacy-policy" className="transition-colors hover:text-brand-green" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="transition-colors hover:text-brand-green" data-testid="footer-terms-link">Terms of Use</Link>
            <Link to="/admin/login" className="transition-colors hover:text-brand-green" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
